import FilteredCalendar from "../../components/calendar/FilteredCalendar";
import { AppDispatch, RootState } from "../../store";
import { fetchUpcomingEvents } from "../../store/reducers/event";
import { Box } from "@radix-ui/themes";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import upcoming_panel from '../../assets/images/upcoming_panel.png';
import viliyo_logo_new from '../../assets/images/viliyo_logo_new.png';

const UpcomingPanel = () => {
  const { items, isLoading } = useSelector((state: RootState) => state.events)
  const dispatch = useDispatch<AppDispatch>()

  useEffect(() => {
    dispatch(fetchUpcomingEvents())
  }, []);

  return (
    <Box className="h-full flex flex-col relative">

      <img
        src={upcoming_panel}
        className="absolute bottom-0 left-0 w-full opacity-10 pointer-events-none"
      />

      {/* Loading */}
      {isLoading && (
        <div className="text-sm text-gray-500 p-2">
          Fetching upcoming sessions...
        </div>
      )}

      {/* Content */}
      {(!isLoading && items.length > 0) && (
        <div className="flex-1 overflow-y-auto">
          <FilteredCalendar events={items} />
        </div>
      )}
      <div className="w-full flex justify-center mt-auto pb-2">
        <div
          style={{
            width: "fit-content",
            display: "flex",
            alignItems: "center",
            // gap: "8px",
            padding: "8px 16px",
            borderRadius: "999px",
            background: "#F3EAD7",
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.08)",
          }}
        >

          <span
            style={{
              fontSize: "13px",
              fontWeight: 700,
              color: "#5F488A",
              letterSpacing: "0.05em",
             fontFamily: "'Lato', sans-serif !important",
            }}
          >
            POWERED BY
          </span>

          <img
            src="Viliyo-Logo2.png"
            alt="Viliyo"
            className="h-[20px] w-auto object-contain -mt-0.5"
          />

        </div>
      </div>
    </Box>
  );
};
export default UpcomingPanel;
